import React from "react";
import { Menu } from "antd";
import { useLocation, Link } from "react-router-dom";
import { useAuth } from "../../../utils/useAuth";
import {
  UserOutlined,
  HomeOutlined,
  CloudUploadOutlined,
  CodeSandboxOutlined,
  FolderOpenOutlined,
  FontColorsOutlined,
  IdcardOutlined,
  DatabaseOutlined,
  UnorderedListOutlined,
  QqOutlined,
  BookOutlined,
  SettingOutlined
} from "@ant-design/icons";

/**
 * MenuItems
 * @param {Boolean} isMenuCollapsed
 * @param {Function} closeDrawer
 */
function MenuItems({ isMenuCollapsed = false, closeDrawer = null }) {
  const { pathname } = useLocation();
  const { isAdmin, isOrganizador } = useAuth();

  return (
    <Menu selectedKeys={[pathname]} mode="inline" theme="light" inlineCollapsed={isMenuCollapsed}>
      <Menu.Item onClick={closeDrawer} key="/app" icon={<HomeOutlined />}>
        <Link to="/app">Inicio</Link>
      </Menu.Item>

      {isAdmin && (
        <Menu.Item onClick={closeDrawer} key="/app/usuarios" icon={<UserOutlined />}>
          <Link to="/app/usuarios">Usuarios</Link>
        </Menu.Item>
      )}

      {(isAdmin || isOrganizador) && (
        <Menu.Item onClick={closeDrawer} key="/app/credenciales" icon={<IdcardOutlined />}>
          <Link to="/app/credenciales">Credenciales</Link>
        </Menu.Item>
      )}

      {isAdmin && (
        <Menu.Item onClick={closeDrawer} key="/app/transferencia" icon={<CloudUploadOutlined />}>
          <Link to="/app/transferencia">Subida archivos</Link>
        </Menu.Item>
      )}

      {(isAdmin || isOrganizador) && (
        <Menu.Item onClick={closeDrawer} key="/app/bdparticipante" icon={<DatabaseOutlined />}>
          <Link to="/app/bdparticipante">BD participante</Link>
        </Menu.Item>
      )}

      <Menu.Item onClick={closeDrawer} key={`/app/participantes/docente`} icon={<BookOutlined />}>
        <Link to={`/app/participantes/docente`}>Docentes</Link>
      </Menu.Item>

      <Menu.Item
        onClick={closeDrawer}
        key={`/app/participantes/administrativo`}
        icon={<FontColorsOutlined />}
      >
        <Link to={`/app/participantes/administrativo`}>Administrativos</Link>
      </Menu.Item>

      <Menu.Item onClick={closeDrawer} key={`/app/participantes/estudiante`} icon={<QqOutlined />}>
        <Link to={`/app/participantes/estudiante`}>Estudiantes</Link>
      </Menu.Item>

      {isAdmin && (
        <Menu.Item onClick={closeDrawer} key="/app/sorteo" icon={<UnorderedListOutlined />}>
          <Link to="/app/sorteo">Sorteos</Link>
        </Menu.Item>
      )}

      {isAdmin && (
        <Menu.Item onClick={closeDrawer} key="/app/sortear" icon={<CodeSandboxOutlined />}>
          <Link to="/app/sortear">Sortear</Link>
        </Menu.Item>
      )}

      {isAdmin && (
        <Menu.Item onClick={closeDrawer} key="/app/reportes" icon={<FolderOpenOutlined />}>
          <Link to="/app/reportes">Reportes</Link>
        </Menu.Item>
      )}

      {isAdmin && (
        <Menu.Item onClick={closeDrawer} key="/app/configuracion" icon={<SettingOutlined />}>
          <Link to="/app/configuracion">Confirguración</Link>
        </Menu.Item>
      )}
    </Menu>
  );
}
export default MenuItems;
